import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@vr/lib';

const GroupIcon = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;

  i {
    color: ${({ theme }) => theme.colors.gold};
  }
`;

const Container = styled.div`
  padding: 40px 0;
  text-align: center;
`;

export const mensagens = {
  500: 'Conteúdo indisponível no momento.',
  502: 'Estamos passando por instabilidades, tente novamente em alguns instantes',
  400: 'Alguma coisa deu errado, tente novamente em alguns instantes',
  404: 'Não conseguimos encontrar o que você estava procurando.',
};

function ErrorMessage({ status, ...rest }) {
  return (
    <Container {...rest}>
      <GroupIcon>
        <FontAwesomeIcon icon={['fal', 'frown']} size="5x" />
      </GroupIcon>
      <p>{mensagens[status]}</p>
    </Container>
  );
}

ErrorMessage.propTypes = {
  status: PropTypes.number,
};

ErrorMessage.defaultProps = {
  status: 500,
};

export default ErrorMessage;
